import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../layouts/PublicLayout';
import { useLocalizedSeo } from '@/utils/localizedSeo';

function Error404(): ReactElement {
    const { t } = useTranslation('error404');

    const metaTitle = t('meta.title');
    const metaDescription = t('meta.description');
    const heading = t('heading');
    const message = t('message');
    const buttonLabel = t('button');

    const { htmlLang, canonicalUrl, alternateLinks } = useLocalizedSeo('/404');

    return (
        <PublicLayout>
            <Helmet htmlAttributes={{ lang: htmlLang }}>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />
                <meta name="robots" content="noindex,nofollow" />
                <link rel="canonical" href={canonicalUrl} />
                {alternateLinks.map(({ lang, href }) => (
                    <link key={lang} rel="alternate" hrefLang={lang} href={href} />
                ))}
            </Helmet>

            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center p-10 rounded-lg">
                    <h1 className="text-6xl font-bold mb-10">{heading}</h1>
                    <p className="text-xl mb-16">{message}</p>

                    <div className="mt-10">
                        <Link
                            to="/desk"
                            className="inline-block bg-gray-700 text-white px-10 py-3 rounded-md hover:bg-gray-800 transition-colors duration-300 w-full max-w-md"
                        >
                            {buttonLabel}
                        </Link>
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
}

export default Error404;
